class ExcelService {
  public export(list: any[], filename: string, addDate: boolean, separator: string) {
    let csvString = '';
    let firstLine = true;
    let delimiter = ';';

    if (separator === '.') {
      delimiter = ',';
    }

    list.forEach((each) => {
      if (firstLine) {
        Object.keys(each).forEach((key) => {
          if (typeof Reflect.get(each, key) !== 'object') {
            const keyName = key.charAt(0).toUpperCase() + key.slice(1);
            csvString += `${keyName}${delimiter}`;
          }
        });
        firstLine = false;
        csvString = csvString.substring(0, csvString.length - 1);
        csvString += '\r\n';
      }
      Object.keys(each).forEach((key) => {
        if (typeof Reflect.get(each, key) !== 'object') {
          csvString += `${Reflect.get(each, key)}${delimiter}`;
        }
      });
      csvString = csvString.substring(0, csvString.length - 1);
      csvString += '\r\n';
    });

    this.createDocument(csvString, filename, addDate);
  }

  private createDocument(csv: string, filename: string, addDate: boolean) {
    const universalBOM = '\uFEFF';
    const filetype = 'data:text/csv; charset=utf-8,';
    const csvString = `${filetype}${encodeURIComponent(universalBOM + csv)}`;
    let name = filename;

    if (addDate) {
      name = `${filename}_${new Date().toLocaleDateString()}.csv`;
    }

    const virtualLink = document.createElement('A');
    virtualLink.setAttribute('href', csvString);
    virtualLink.setAttribute('download', name);
    document.body.appendChild(virtualLink);

    virtualLink.click();
  }
}

export default new ExcelService();
